/* ================================================================ */
// MENU CONTAINER | Menu.jsx
/* ================================================================ */
/* ========================================== */
// Imports
/* ========================================== */
import React, {Suspense} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
// Material UI
import makeStyles from '@material-ui/styles/makeStyles';
import Skeleton from '@material-ui/lab/Skeleton';
// Library Components
import {MenuTypes} from '@myglobe/core/dist/types';
const TabMenu = React.lazy(()=>import('@myglobe/core/dist/Menu/TabMenu'));
const ListMenu = React.lazy(()=>import('@myglobe/core/dist/Menu/ListMenu'));
const TimelineMenu = React.lazy(()=>import('@myglobe/core/dist/Menu/TimelineMenu'));
/* ========================================== */
// Style Settings
/* ========================================== */
const useStyles = makeStyles(() => ({
    root: {
        // TODO: revert this stuff to a more flexible menu
        '&.list': {
            height: 'calc(100% - 12em)',
            maxHeight: 'calc(100vh - 12em)'
        }
    }
}));
/* ========================================== */
/**
 * Menu Container
 * --------------
 * Outputs menu according to given type and
 * menu items
 *
 * @param {object} props component props
 * @param {object} props.styles style overrides
 * @param {object} props.type menu layout type
 * @param {array} props.items menu item config array
 */
/* ========================================== */
const Menu = (props) => {
    const classes = useStyles();
    const {type, items, styles, ...otherProps} = props;
    const rootClasses = classNames(
        classes.root,
        {
            'list': type === MenuTypes.LIST
        }
    );
    const MenuOutput = ({type}) => {
        {switch(type) {
        case MenuTypes.TAB:
            return <TabMenu items={items} otherProps={otherProps} />;
        case MenuTypes.LIST:
            return <ListMenu items={items} otherProps={otherProps} />;
        case MenuTypes.TIMELINE:
            return <TimelineMenu items={items} otherProps={otherProps} />;
        default:
            return <ListMenu items={items} otherProps={otherProps} />;
        }}
    };
    /* ======================== */
    // RENDER
    /* ======================== */
    return (
        <section className={rootClasses} style={styles}>
            <Suspense fallback={<Skeleton variant="text" width="100%" height="100%" />}>
                <MenuOutput type={type} />
            </Suspense>
        </section>
    );
};
/* ======================== */
// PROPS
/* ======================== */
Menu.propTypes = {
    screen: PropTypes.shape({
        width: PropTypes.number.isRequired,
        height: PropTypes.number.isRequired
    }),
    styles: PropTypes.object,
    type: PropTypes.oneOf(Object.values(MenuTypes)),
    items: PropTypes.arrayOf(PropTypes.shape({
        title: PropTypes.string.isRequired,
        icon: PropTypes.string,
        path: PropTypes.string.isRequired,
        styles: PropTypes.object,
        items: PropTypes.arrayOf(PropTypes.shape({
            title: PropTypes.string.isRequired,
            icon: PropTypes.string,
            path: PropTypes.string.isRequired,
            styles: PropTypes.object
        }))
    }))
};
Menu.defaultProps = {
    styles: {},
    items: []
};
/* ========================================== */
// Export
/* ========================================== */
export default Menu;